import { CryptoContext } from '../base';
import { NanoOwnConfigLoadArgs, NanoOwnConfigDumpArgs } from './args';
import { NanoOwnConfigV1 } from './v1';
import { CU_BASE } from '../feature';

export let NANO_OWN_CRYPTO_CONTEXT = new CryptoContext<
  NanoOwnConfigLoadArgs,
  NanoOwnConfigDumpArgs
>([new NanoOwnConfigV1(CU_BASE)]);
